import { IGoogleCalendarOutOfOfficeNotification } from '@/types/workflows/workflow-action/IWorkflowAction';

/**
 * Default configuration for a webinar.
 */
export const WF_ACTION_OOO: IGoogleCalendarOutOfOfficeNotification = {
	type: 'GoogleCalendarOutOfOfficeNotification',
	calendarId: {
		account: {
			account: '',
			provider: 'GOOGLE',
			userId: {
				id: '',
			},
		},
		providerCalendarId: '',
	},
};
